//frontend/src/components/AddGardenerForm.js
import React, { useState, useEffect, useContext } from 'react';
import './AddGardenerForm.css';
import './Buttons.css';
import './Instructions.css';
import GardenerFormInstructions from './Utilities/GardenerFormInstructions';
import EmailVerification from './EmailVerification';
import api from '../api';

const AddGardenerForm = ({ onUpdateGardener, onAddPlant, onRemovePlant, handleTabChange, isDemoMode  }) => {
    const [gardener, setGardener] = useState({
        name: '',
        email: '',
        phone: '',
        locationID: '',
        familysize: '',
        experienceLevel: '',
        city: '',
        province: '',
        country: '',
        plantID: '',
        plantType: ''
    });
    const [plants, setPlants] = useState([]);
    const [locations, setLocations] = useState([]);
    const [currentGardener, setCurrentGardener] = useState(null);
    const [userPlants, setUserPlants] = useState([]);
    const [report, setReport] = useState([]);
    const [showInstructions, setShowInstructions] = useState(false);
    const [showEmailVerification, setShowEmailVerification] = useState(false);
    const [emailVerificationMessage, setEmailVerificationMessage] = useState("");

    const locationParts = [
        gardener.city?.trim(),
        gardener.province?.trim(),
        gardener.country?.trim()
    ].filter(Boolean);

    const formattedLocation = locationParts.join(', ');


    const handleLocationChange = (e) => {
        console.log("ComboBox value selected:", e.target.value); // Log the value selected from combo box
        console.log("locations array", locations);
        const selectedLocation = locations.find((location) => location.id.toString() === e.target.value);

        console.log("Selected location ID:", e.target.value); // Debug statement for selected location ID
        console.log("Selected location object:", selectedLocation); // Debug statement for selected location object

        if (selectedLocation) {
            const updatedGardener = {
                ...gardener,
                locationID: e.target.value,
                city: selectedLocation.city,
                province: selectedLocation.province,
                country: selectedLocation.country
            };

            setGardener(updatedGardener);
        } else {
            console.log("No valid location selected."); // Debug statement for invalid selection
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            const form = e.target.form;
            const index = Array.prototype.indexOf.call(form, e.target);
            form.elements[index + 1]?.focus();
        }
    };


    useEffect(() => {
        const fetchPlants = async () => {
            try {
                const response = await api.get('/plants/all');
                const data = response.data;
                console.log(data);
                setPlants(data);
            } catch (err) {
                console.error('Error fetching plants:', err);
            }
        };

        const fetchLocations = async () => {
            try {
                console.log('about to call the location route');
                const response = await api.get('/locations/all');
                const data = response.data;
                console.log('About to fill in the location combo box');
                console.log(data);
                setLocations(data);
            } catch (err) {
                console.error('Error fetching locations:', err);
            }
        };

        fetchPlants();
        fetchLocations();
    }, []);

    // Function to fetch current gardener info and their plants
    const fetchCurrentGardener = async () => {
        try {
                const response = await api.get('/gardeners/current', {
                    params: { demoMode: isDemoMode }
                });
                const data = response.data;
    console.log(' Fetched currentGardener:', data);
    console.log(' isDemoMode:', isDemoMode);
            setCurrentGardener(data);
            console.log('the currentgardener locationid:', data.locationID);
            setGardener({ ...data, plant: '', });
            fetchGardenerPlants(data.id); // Fetch gardener plants
            return data;
        } catch (err) {
            if (err.response?.status === 404) {
                setCurrentGardener(null); // No gardener found
            }
            console.error('Error fetching current gardener:', err);
            return null;
        }
    };

    const fetchGardenerPlants = async (gardenerID) => {
        try {
            const response = await api.get(`/gardenerPlants/${gardenerID}`);
            const data = response.data;
            setUserPlants(data);
        } catch (err) {
            console.error('Error fetching plants:', err);
        }
    };

    // Fetch current gardener info and their plants on component mount
    useEffect(() => {
        if (typeof isDemoMode === 'boolean') {
            fetchCurrentGardener();
        }
       }, [isDemoMode]);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setGardener((prevGardener) => {
            if (name === 'plantID') {
                const selectedPlant = plants.find((plant) => plant.plantID.toString() === value);
                if (selectedPlant) {
                    console.log(`Selected plant name: ${selectedPlant.name}`);
                    console.log(`Selected plant ID: ${selectedPlant.plantID}`);
                }
            }
            return {
                ...prevGardener,
                [name]: value,
                ...(name==='email' ? {emailVerified: false } : {})
            };
        });

        console.log(`${name} changed to ${value}`); // Log changes to verify
    };



    const handleAddPlant = (e) => {
        e.preventDefault()
        onAddPlant({ plantID: gardener.plantID, plantType: gardener.plantType });
    };

    const handleRemovePlant = (e) => {
        e.preventDefault()
        onRemovePlant(gardener.plantID);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!gardener.email || gardener.email.trim() === "") {
            alert("Email is required.");
            return;
        }

        // If email changed, check if it's already used
        if (gardener.email !== currentGardener.email) {
            try {
                await api.post("/gardeners/check-email", { email: gardener.email });
            } catch (err) {
                alert("This email is already used by another gardener.");
                return; 
            }
        }

        if (!gardener.emailVerified){
            // Instead of saving directly, trigger verification
            setEmailVerificationMessage("Please verify your new email address.");
            setShowEmailVerification(true);
            return;
        }

        onUpdateGardener(gardener);
    };

    return (
        <div className="add-gardener-form">
            <h2 className="form-heading">Tend to Your Gardener Info</h2>

            <form id="gardener-form">
                <button
                    type="button"
                    className="button tooltip"
                    aria-label="Toggle help panel with form instructions"
                    onClick={() => setShowInstructions(prev => !prev)}
                    aria-expanded={showInstructions}
                    aria-controls="gardener-instructions"
                >
                    {showInstructions ? 'Hide Help' : 'Show Help'}
                </button>

                {showInstructions && (
                    <div className="instructions-panel">
                        <GardenerFormInstructions />
                    </div>
                )}

                <div className="gardener-form-row">
                    <label htmlFor="name" className="gardener-form-label tooltip" aria-label="Used to personalize your gardener profile">
                        First Name:
                    </label>
                    <div className='tooltip' aria-label="Used to personalize your gardener profile">
                    <input
                            type="text"
                            name="name"
                            id="name"
                            value={gardener.name}
                            onChange={handleChange}
                            placeholder="Enter your name"
                            required
                            className="gardener-form-input"
                            autoFocus
                            onKeyDown={handleKeyDown }
                    />
                    </div>
                </div>

                <div className="gardener-form-row">
                    <label htmlFor="eMail" className="gardener-form-label tooltip" aria-label="Used to send forgot password reset link and reports">
                        eMail:
                    </label>
                    <div className='tooltip' aria-label="Used to send forgot password reset link and reports">
                    <input
                            type="text"
                            name="email"
                            id="email"
                            value={gardener.email}
                            onChange={handleChange}
                            placeholder="Enter your eMail"
                            required
                            className="gardener-form-input"
                            autoFocus
                            onKeyDown={handleKeyDown }
                    />
                    </div>
                </div>

                <div className="gardener-form-row">
                    <label htmlFor="location" className="gardener-form-label tooltip" aria-label="Used to match your garden with local weather and planting zones">
                        Location:
                    </label>
                    <div className="tooltip" aria-label="Used to match your garden with local weather and planting zones">
                    <select
                            name="location"
                            id="location"
                            onChange={handleLocationChange}
                            className="gardener-form-input"
                            onkeyDown={handleKeyDown }
                    >
                        <option value="">Select your location</option>
                        {locations.map((location) => (
                            <option key={location.id} value={location.id}>
                                {location.city}, {location.province}, {location.country}
                            </option>
                        ))}
                        </select>
                    </div>
                </div>

                <div className="location-display-inline">
                    <span className="gardener-value">
                        {formattedLocation}
                        <span className="location-note"> (used for weather station)</span>
                    </span>
                </div>

                <div className="gardener-form-row">
                    <label htmlFor="familysize" className="gardener-form-label tooltip" aria-label="Helps estimate how much food to grow">
                        Family Size:
                    </label>
                    <div className="tooltip" aria-label="Helps estimate how much food to grow">
                    <input
                            type="number"
                            name="familysize"
                            id="familysize"
                            value={gardener.familysize}
                            onChange={handleChange}
                            placeholder="Enter the size of your family"
                            required
                            className="gardener-form-input"
                            onKeyDown={handleKeyDown }
                        />
                    </div>
                </div>

                <div className="gardener-form-row">
                    <label htmlFor="experienceLevel" className="gardener-form-label tooltip" aria-label="Used to tailor your seasonal tasks and guidance">
                        Gardening Experience:
                    </label>
                    <div className="tooltip" aria-label="Used to tailor your seasonal tasks and guidance">
                    <select
                            name="experienceLevel"
                            id="experienceLevel"
                            value={gardener.experienceLevel}
                            onChange={handleChange}
                            required
                            className="gardener-form-input"
                            onKeyDown={handleKeyDown }
                    >
                        <option value="">Select your level</option>
                        <option value="Beginner">Beginner</option>
                        <option value="Intermediate">Intermediate</option>
                        <option value="Seasoned">Seasoned</option>
                        </select>
                    </div>
                </div>

                {currentGardener && (
                  <>
                    <button 
                        onClick={handleSubmit} 
                        className="button tooltip" 
                        aria-label="Save changes to your gardener profile"
                        disabled={isDemoMode}
                     >
                        Update Gardener
                    </button>
                    {isDemoMode && (
                        <p className="demo-hint">Updating gardener info is disabled in demo mode.</p>
                    )}
                 </>
                ) }

            </form>
                {showEmailVerification && (
                    <div className="cart-overlay">
                        <EmailVerification
                            gardener={gardener}
                            message={emailVerificationMessage}
                            onClose={() => setShowEmailVerification(false)}
                            onVerified={(verifiedEmail) => {
                                // update local form state only
                                setGardener(prev => ({
                                    ...prev,
                                    email: verifiedEmail,
                                    emailVerified: true
                                }));
                                setShowEmailVerification(false);

                                onUpdateGardener({
                                    ...gardener,
                                    email: verifiedEmail,
                                    emailVerified: true
                                });
                }}
                />
                </div>
                )}

        </div>
    );
};

export default AddGardenerForm;

